var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "sip-footer-content d-flex align-items-center justify-content-between w-100",
    },
    [
      _c("span", { staticClass: "sip-footer-copy" }, [
        _vm._v(
          "\n        Copyright © " +
            _vm._s(_vm.currentYear) +
            " Sipinor Educational Solutions. All rights reserved.\n    "
        ),
      ]),
      _vm._v(" "),
      _c(
        "span",
        { staticClass: "sip-footer-credit text-muted d-none d-sm-inline" },
        [_vm._v("\n        Made with Love & Care in Pink City.\n    ")]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }